import React from "react";
import { Link } from "react-router-dom";

function AccountSuccess() {
  return (
    <div className="account-success-container">
      <div className="account-success-content">
        <h5>Account Information Received!</h5>
        <p>You will be able to login in soon pending administrator approval.</p>
        <Link to="/admin/login" className="back-to-home-link">
          Back to Login
        </Link>
      </div>
    </div>
  );
}

export default AccountSuccess;
